export default __webpack_public_path__ + "static/media/_498.7640b2f4.jpg";